import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as proposals from '../../proposals'

export const RESOURCE = {
  payload: {
    description:
      'A formal request for funding or approval, typically submitted to a governing body or organization for consideration.',
    dimension: proposals.RESOURCE.payload,
    level: 0,
    name: 'Proposal',
    partialId: PartialId.Standard.create('proposal'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
